var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './VerticalColumnView.scss';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { Row } from 'antd';
import React from 'react';
import { ViewArea } from '@ui/general';
export const VerticalColumnView = (_a) => {
    var { children, loading } = _a, rest = __rest(_a, ["children", "loading"]);
    return React.createElement(ViewArea, Object.assign({ className: 'vertical-column-view', direction: 'vertical', fullWidth: true }, rest),
        React.createElement(LoadingSpinner, { spinning: loading },
            React.createElement("div", { className: 'vertical-column-view-content' },
                React.createElement(Row, { gutter: 8 }, children))));
};
